import Invite from '../components/invite/invite'

export default {
  Invite
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/resources/components.js